// creating a map of the previous Icon available names to the new nova version ones
// so as to make the Icon values utilized in Contentful not break the UI
export const ICON_SRC_MAP: Record<string, string> = {
  AddOtherDevice: 'add-other-device',
  Amplifier: 'amplifier',
  ArrowDown: 'arrow-down',
  ArrowLeft: 'arrow-left',
  ArrowRight: 'arrow-right',
  ArrowsNavigationHeader: 'arrows-navigation-header',
  ArrowUp: 'arrow-up',
  AsurionLogo: 'asurion-logo',
  Bin: 'bin',
  BuiltInFoodCenter: 'built-in-food-center',
  Calendar: 'calendar',
  Camera: 'camera',
  Camera1: 'camera-1',
  CardsNavigationChevronBottom: 'cards-navigation-chevron-bottom',
  CardsNavigationChevronLeft: 'cards-navigation-chevron-left',
  CardsNavigationChevronRight: 'cards-navigation-chevron-right',
  CardsNavigationChevronUp: 'cards-navigation-chevron-up',
  ChatBubbleCircle: 'chat-bubble-circle',
  'ChatBubbleCircleCheck-2': 'chat-bubble-circle-check-2',
  ChatBubblesCircle: 'chat-bubbles-circle',
  CheckmarkV: 'checkmark-v',
  ChevronDown: 'chevron-down',
  ChevronLeft: 'chevron-left',
  ChevronRight: 'chevron-right',
  ChevronUp: 'chevron-up',
  CloseX: 'close-x',
  Cooktop: 'cooktop',
  Copy: 'copy',
  DataDownload: 'data-download',
  DataUpload: 'data-upload',
  DesktopComputer: 'desktop-computer',
  Dishwasher: 'dishwasher',
  Dryer: 'dryer',
  DVDBluerayPlayer: 'dvd-blueray-player',
  EditPencilChange: 'edit-pencil-change',
  EmailEnvelope: 'email-envelope',
  EReader: 'e-reader',
  ExternalHardDrive: 'external-hard-drive',
  ExternalMonitor: 'external-monitor',
  ExternalSpeakers: 'external-speakers',
  'FileEdit-2': 'file-edit-2',
  FitnessTracker: 'fitness-tracker',
  Freezer: 'freezer',
  Fridge: 'fridge',
  GamingConsole: 'gaming-console',
  GamingRemote: 'gaming-remote',
  HamburgerMenu: 'hamburger-menu',
  Headphones: 'headphones',
  HeartLoveVote: 'heart-love-vote',
  Hub: 'hub',
  IceMaker: 'ice-maker',
  IconPlaceholder: 'icon-placeholder',
  InputSendImage: 'input-send-image',
  Keyboard: 'keyboard',
  Laptop: 'laptop',
  'Laptop-2': 'laptop-2',
  LocationMap: 'location-map',
  LocationPin: 'location-pin',
  LocationPinMiles: 'location-pin-miles',
  LocationTarget: 'location-target',
  MegaphoneCallout: 'megaphone-callout',
  Microwave: 'microwave',
  MinusDelete: 'minus-delete',
  Modem: 'modem',
  Mouse: 'mouse',
  NotificationBell: 'notification-bell',
  NotificationStatusDotCircleIndicator:
    'notification-status-dot-circle-indicator',
  Oven: 'oven',
  Phone: 'phone',
  'PictureLayer-2': 'picture-layer-2',
  PlusAdd: 'plus-add',
  PortableGamingConsole: 'portable-gaming-console',
  Printer: 'printer',
  PrinterUI: 'printer-ui',
  Projector: 'projector',
  Refresh: 'refresh',
  RemoteControl: 'remote-control',
  RoundedUser: 'rounded-user',
  Router: 'router',
  SearchMagnifyGlass: 'search-magnify-glass',
  Send: 'send',
  ServicesMenu: 'services-menu',
  Settings: 'settings',
  'Settings-1': 'settings-1',
  Share: 'share',
  'Shield-8': 'shield-8',
  SmartAlarmContactSensor: 'smart-alarm-contact-sensor',
  SmartAlarmFloodAndFreezeSensor: 'smart-alarm-flood-and-freeze-sensor',
  SmartAlarmGlassBreakSensor: 'smart-alarm-glass-break-sensor',
  SmartAlarmKeypad: 'smart-alarm-keypad',
  SmartAlarmMotionDetector: 'smart-alarm-motion-detector',
  SmartAlarmPanicButton: 'smart-alarm-panic-button',
  SmartAlarmRangeExtender: 'smart-alarm-range-extender',
  SmartDoorBell: 'smart-door-bell',
  SmartDoorLock: 'smart-door-lock',
  SmartLightDimmer: 'smart-light-dimmer',
  Smartphone: 'smartphone',
  SmartSecurityCam: 'smart-security-cam',
  SmartSmokeDetector: 'smart-smoke-detector',
  SmartSpeaker: 'smart-speaker',
  SmartThermostat: 'smart-thermostat',
  SmartWatch: 'smart-watch',
  Smiley: 'smiley',
  Soundbar: 'soundbar',
  Stove: 'stove',
  StreamingDevice: 'streaming-device',
  Subwoofer: 'subwoofer',
  SystemAlertAlert: 'system-alert-alert',
  SystemAlertCheckmark: 'system-alert-checkmark',
  SystemAlertWarning: 'system-alert-warning',
  SystemAlertXNo: 'system-alert-x-no',
  SystemBlockedNoEntry: 'system-blocked-no-entry',
  SystemHelp: 'system-help',
  SystemInformation: 'system-information',
  Tablet: 'tablet',
  ThreeDotsMenuOptions: 'three-dots-menu-options',
  Time: 'time',
  TrashCompactor: 'trash-compactor',
  TriangleChevronDown: 'triangle-chevron-down',
  TriangleChevronLeft: 'triangle-chevron-left',
  TriangleChevronRight: 'triangle-chevron-right',
  TriangleChevronUp: 'triangle-chevron-up',
  Tuner: 'tuner',
  TV: 'tv',
  User: 'user',
  UserHome: 'user-home',
  VRHeadset: 'vr-headset',
  Washer: 'washer',
  Wifi: 'wifi',
  WirelessSpeaker: 'wireless-speaker-test-2',
  Wrench: 'wrench',
};
